import A from './types';
// import filter from 'lodash/filter';
import resourceId from '~/misc/resourceId';
import {fallbackToArray, ensureQueryDefaults} from '~/misc/search';
import safeJSONParse from '~/misc/safeJSONParse';
import getStorageValue from '~/misc/getStorageValue';
import {inputValuesAll} from '~/misc/equipment';

const getResourceIdentity = (queryCompleted) => resourceId('myloads', {
  query: queryCompleted,
});

const init = () => ({
  dialog: false,
  saved: {
    identity: getResourceIdentity(null),
    query: ensureQueryDefaults({
      equipment: fallbackToArray(safeJSONParse(getStorageValue('equipment'))).filter(i => inputValuesAll.includes(i)),
      loadSize: 'full',
    }),
    status: '',
  },
  hide: {
    identity: getResourceIdentity(null),
    query: ensureQueryDefaults({
      equipment: fallbackToArray(safeJSONParse(getStorageValue('equipment'))).filter(i => inputValuesAll.includes(i)),
      loadSize: 'full',
    }),
    status: '',
  },
  viewed: {
    identity: getResourceIdentity(null),
    query: ensureQueryDefaults({
      equipment: fallbackToArray(safeJSONParse(getStorageValue('equipment'))).filter(i => inputValuesAll.includes(i)),
      loadSize: 'full',
    }),
    status: '',
  },
  bid: {
    identity: getResourceIdentity(null),
    query: ensureQueryDefaults({
      equipment: fallbackToArray(safeJSONParse(getStorageValue('equipment'))).filter(i => inputValuesAll.includes(i)),
      loadSize: 'full',
    }),
    status: '',
  },
  booking:{
    identity: getResourceIdentity(null),
    query: ensureQueryDefaults({
      equipment: fallbackToArray(safeJSONParse(getStorageValue('equipment'))).filter(i => inputValuesAll.includes(i)),
      loadSize: 'full',
    }),
    status: '',
  },
  bookingDeleted: [],
});

const reducer = (state, action) => {
  switch (action.type) {
    case A.CHECK_DIALOG: {
      const bol = action.payload.bol;
      return {dialog: bol};
    }
    case A.UPDATE_MYLOADS: {
      let myloads = state[action.payload.type];
      let saved = action.payload.val.shipments.map(item => ({
        ...item,
        identity: resourceId(action.payload.type, {
          id: item.id,
        }, myloads.identity),
        parentIdentity: myloads.identity,
      }));
      myloads = {
        ...myloads,
        search_since: '',
        fetchedAt: new Date(),
        updatesEnabled: true,
        tooManyUpdates: false,
        deletedIndex: {},
        results: {
          shipments: saved,
          hasItems: Boolean(saved.length),
          total: saved.length,
        },
        status: 'success',
      };
      return {
        [action.payload.type]: myloads,
      };
    }
    case A.UPDATE_STATUS: {
      const type = action.payload.type;
      return {
        [type]: {
          ...state[type],
          status: action.payload.status,
        },
      };
    }
    case A.SAVE_BROKER:
    case A.NO_SAVE_BROKER: {
      return {
        saved: {
          ...state.saved,
          results: {
            ...state.saved.results,
            shipments: action.payload.savedArr,
          },
        },
        hide: {
          ...state.hide,
          results: {
            ...state.hide.results,
            shipments: action.payload.hideArr,
          },
        },
        viewed: {
          ...state.viewed,
          results: {
            ...state.viewed.results,
            shipments: action.payload.viewedArr,
          },
        },
        bid: {
          ...state.bid,
          results: {
            ...state.bid.results,
            shipments: action.payload.bidArr,
          },
        },
        booking: {
          ...state.booking,
          results: {
            ...state.booking.results,
            shipments: action.payload.bookingArr,
          },
        },
      };
    }
    case A.DELETE_BOOKING_LOADS:{
      const newArray = [...state.bookingDeleted, action.payload.loadId]
      return {
        bookingDeleted: newArray
      }
    }
  }
  return null;
};

export default {reducer, init};



// WEBPACK FOOTER //
// ./src/modules/myLoads/reducer.js